/*
 *
 * LanguageProvider constants
 *
 */

export const CHANGE_LOCALE = 'app/LanguageToggle/CHANGE_LOCALE';
export const LOAD_LOCALE = 'app/LanguageToggle/LOAD_LOCALE';
